import { render, staticRenderFns } from "./ACorreoCertificados.vue?vue&type=template&id=190d2988"
import script from "./ACorreoCertificados.vue?vue&type=script&lang=js"
export * from "./ACorreoCertificados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports